import {throttle} from 'throttle-debounce';

// Get and store common metrics such as viewport dims and scroll positions
// ------------------------------------------------------

var m = {
  page_scrolling: false
};

// Update on resize
// ------------------------------------------------------
function onResize() {
  m.win_height = window.innerHeight;
  m.win_width = window.innerWidth;

  m.offsets = {
    full: m.win_height,
    'half': m.win_height / 2,
    'third': m.win_height / 3 * 2,
    'fourth': m.win_height / 4 * 3,
    'two-third': m.win_height - (m.win_height / 3 * 2),
  };

  // TODO - Dry this out, probably move all code to the solution in core
  m.offsets_end = {
    'full': 0,
    'half': m.win_height / 2,
    'third': m.win_height / 3,
    'fourth': m.win_height / 4,
    'two-third': m.win_height / 3 * 2,
  };
}

var onResize_throttled = throttle(5, onResize);

// Update on scroll
// ------------------------------------------------------
function onScroll() {
  m.scroll_y = window.pageYOffset;
}

var onScroll_throttled = throttle(5, onScroll);

// Bind events
// ------------------------------------------------------
function bindEvents() {
  window.addEventListener('resize', onResize_throttled);
  window.addEventListener('scroll', onScroll_throttled);
}

// Kickoff
// ------------------------------------------------------

// Get and set initial values
onResize();
onScroll();

// Bind events
bindEvents();


export default function get(name) {
  return m[name];
};

